export default class AccomplishmentUtils {
  public static getStatusColor = (instance: string) => {
    const status = (instance = instance.replace("_", " "));

    switch (status) {
      case "APPROVED":
        return "green";
      case "PENDING":
        return "orange";
      case "REJECTED":
        return "red";
      default:
        return "GREY";
    }
  };

  public static lowercaseExceptFirst = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
}
